import _ from 'lodash';
import React from 'react';
import useSWR from 'swr';
import Markdown from 'markdown-to-jsx';

import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import Footer from 'components/Footer';

import { swrFetcher } from 'utils/api';

import { useAppLaunch } from 'contexts/AppLaunch';

const { useState } = React;

const markdownOptions = {
  overrides: {
    // img: {
    //   component: (props) => {
    //     const { title, alt, src } = props;
    //     return (
    //       <div className="py-5">
    //         <img
    //           {...props}
    //           alt={alt}
    //           title={title}
    //           src={src}
    //           className="w-full rounded-lg"
    //         />
    //         {alt && (
    //           <p className="mt-3 text-sm text-gray-500 text-center">{alt}</p>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    a: {
      props: {
        target: '_blank',
        style: {
          color: '#5882ff',
        },
        className: 'underline cursor-pointer',
      },
    },
    // p: {
    //   props: {
    //     className: 'leading-normal',
    //     // className: 'lg:text-sm text-base leading-normal',
    //   },
    // },
    // h1: {
    //   props: {
    //     className: 'text-2xl text-gray-900 font-bold',
    //   },
    // },
    // ul: {
    //   props: {
    //     className: 'ml-4 py-6 text-xl list-disc list-inside',
    //   },
    // },
    // li: {
    //   props: {
    //     className: 'py-1',
    //   },
    // },
    // h2: {
    //   props: {
    //     style: {
    //       color: '#4a4a4a',
    //     },
    //     className: 'font-pfm text-lg my-4 leading-normal',
    //   },
    // },
    // h3: {
    //   props: {
    //     style: {
    //       color: '#f16b7c',
    //     },
    //     className: 'font-pfm text-xs leading-normal',
    //   },
    // },

    // strong: {
    //   props: {
    //     style: {
    //       color: '#f16b7c',
    //     },
    //     className: 'leading-normal',
    //   },
    // },
  },
};

const FAQQuestion = (props) => {
  const { question: q } = props;
  const { question, answer } = q;
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="mb-3 border-b border-[#e7e7e7] lg:mb-5">
      <div
        className="mb-3 flex cursor-pointer items-center justify-between lg:mb-5"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="text-base font-medium text-[#111928]">{question}</p>
        <img
          className="h-6 w-6 transform transition-transform duration-300"
          src="/images/faq-chevron.png"
          alt="icon"
          style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
        />
      </div>
      {isOpen && (
        <div className="prose prose-sm !max-w-full pb-3 text-sm leading-normal text-[#4a4a4a] lg:pb-5 lg:text-base">
          <Markdown options={markdownOptions}>{answer || ''}</Markdown>
        </div>
      )}
    </div>
  );
};

const FAQSection = (props) => {
  const { section } = props;
  const { title, questions } = section;
  return (
    <div className="">
      <div className="mb-7 flex items-center lg:mb-11">
        <div className="mr-3 h-5 w-4">
          <img
            className="h-full w-full object-contain"
            src="/images/faq-title.png"
            alt="icon"
          />
        </div>
        <p className="text-xl font-medium text-sorra-pink lg:text-2xl">
          {title}
        </p>
      </div>
      <div className="flex flex-col">
        {questions.map((question) => {
          return <FAQQuestion key={question.id} question={question} />;
        })}
      </div>
    </div>
  );
};

export default function FAQ(props) {
  const { notifications } = useAppLaunch();
  const { data: faq } = useSWR('/api/v3/faq', swrFetcher, {
    fallbackData: {
      sections: [],
    },
  });

  const { sections } = faq;

  return (
    <div>
      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'Ranking',
          }}
        />
        <div
          className={
            'globals-centerContentsMargin relative' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
          //   style={{ backgroundImage: 'url(/images/bg-ranking.png)' }}
        >
          <div
            className="h-[77px] w-full lg:h-[136px]"
            style={{
              background:
                'linear-gradient(91deg, #FFF4E7 40.8%, #FFEAEA 100.11%)',
            }}
          >
            <MaxWidthContainer className="flex h-full items-center px-4 lg:px-20">
              <p className="text-[30px] font-bold lg:text-[48px]">FAQ</p>
            </MaxWidthContainer>
          </div>
          <MaxWidthContainer className="mb-12 mt-6 min-h-screen px-4 lg:mb-24 lg:mt-12">
            <div className="flex flex-col gap-y-9 lg:gap-y-12">
              {sections.map((section) => {
                return <FAQSection key={section.id} section={section} />;
              })}
            </div>
          </MaxWidthContainer>
        </div>

        <Footer />

        <MobileTabBar props={{}} />
      </main>
    </div>
  );
}
